<script>
  import { cart, stage, formdata, user, Stages } from './storage.js';
  import FormField from '@smui/form-field';
  import Textfield from '@smui/textfield';
  import Checkbox from '@smui/checkbox';
  import BillingAddress from './BillingAddress.svelte';
  import DeliveryAddress from './DeliveryAddress.svelte';
  import BasicData from './BasicData.svelte';
  import Button, { Label } from '@smui/button';
  import { Icon } from '@smui/common';
  import Accordion, { Panel, Header, Content } from '@smui-extra/accordion';

  let comment = '';
  let sameAddress = true;
  let privacy_policy = false;
  let regulations = false;

  let basicData;
  let billingAddress;
  let deliveryAddress;

  let panels = {
    basic: {
      open: true,
      done: false,
      active: true
    },
    billing: {
      open: false,
      done: false,
      active: false
    },
    delivery: {
      open: false,
      done: false,
      active: false
    },
    notes: {
      open: false,
      done: false,
      active: false
    },
    agreements: {
      open: false,
      done: false,
      active: false
    }
  }

  if ($cart.all_digital) delete panels.delivery;

  const done = (name) => {
    const keys = Object.keys(panels);
    let next = keys[keys.indexOf(name) + 1];

    if (!panels[name].value) {
      panels[name].value = true;
      panels[next].active = true;
    }

    panels[name].open = false;
    panels[next].open = true;
  }

  const checkAgreements = (a1, a2) => {
    if (a1 && a2) {
      panels.agreements.value = true;
      panels.agreements.open = false;
    };
  }

  $: checkAgreements(regulations, privacy_policy);

  const submitForm = () => {
    if (!billingAddress.b2b) {
      billingAddress.tax_id = null;
      billingAddress.company_name = null;
    }

    let payload = {
      billing_address_attributes: {...billingAddress},
      privacy_policy: privacy_policy,
      regulations: regulations,
      comment: comment,
      ...basicData
    }

    if (billingAddress.b2b) {
      payload.invoice = true;
      payload.tax_id = billingAddress.tax_id;
      
      if (!billingAddress.first_name) {
        delete payload.billing_address_attributes.first_name;
      }

      if (!billingAddress.last_name) {
        delete payload.billing_address_attributes.last_name;
      }
    }

    delete payload.billing_address_attributes.tax_id;

    if (!sameAddress) {
      payload.delivery_address_attributes = {...deliveryAddress};
    }

    if ($user) {
      payload.user_id = $user.id;
    }

    $formdata = payload;
    $stage = Stages.SUMMARY;
  }
</script>

<h1>Formularz zamówienia</h1>

<Accordion>
  <Panel class="acc" bind:open={panels.basic.open} nonInteractive={!panels.basic.active}>
    <Header>
      <strong>Dane kontaktowe</strong>
      <div slot="icon">
        <Icon class="material-icons">{panels.basic.value ? 'check' : ''}</Icon>
        <Icon class="material-icons">{panels.basic.active && !panels.basic.value ? 'edit' : ''}</Icon>
      </div>
    </Header>
    <Content>
      {#if panels.basic.open}
        <BasicData bind:fields={basicData} on:done={() => done('basic')} />
      {/if}
    </Content>
  </Panel>

  <Panel class="acc" bind:open={panels.billing.open} nonInteractive={!panels.billing.active}>
    <Header>
      <strong>Adres rozliczeniowy</strong>
      <div slot="icon">
        <Icon class="material-icons">{panels.billing.value ? 'check' : ''}</Icon>
        <Icon class="material-icons">{panels.billing.active && !panels.billing.value ? 'edit' : ''}</Icon>
      </div>
    </Header>
    <Content>
      {#if panels.billing.open}
        <BillingAddress bind:fields={billingAddress} on:done={() => done('billing')} />
      {/if}
    </Content>
  </Panel>

  {#if !$cart.all_digital}
    <Panel class="acc"  bind:open={panels.delivery.open} nonInteractive={!panels.delivery.active}>
      <Header>
        <strong>Adres dostawy</strong>
        <div slot="icon">
          <Icon class="material-icons">{panels.delivery.value ? 'check' : ''}</Icon>
          <Icon class="material-icons">{panels.delivery.active && !panels.delivery.value ? 'edit' : ''}</Icon>
        </div>
      </Header>
      <Content>
        {#if panels.delivery.open}
          <DeliveryAddress bind:fields={deliveryAddress} bind:sameAddress on:done={() => done('delivery')} />
        {/if}
      </Content>
    </Panel>
  {/if}

  <Panel class="acc"  bind:open={panels.notes.open} nonInteractive={!panels.notes.active}>
    <Header>
      <strong>Uwagi do zamówienia</strong>
      <div slot="icon">
        <Icon class="material-icons">{panels.notes.value ? 'check' : ''}</Icon>
        <Icon class="material-icons">{panels.notes.active && !panels.notes.value ? 'edit' : ''}</Icon>
      </div>
    </Header>
    <Content>
      <div class="row row-1">
        <Textfield bind:value={comment}
          textarea
          style="width: 100%;"
          helperLine$style="width: 100%;"
          label="Twoje uwagi">
        </Textfield>
      </div>

      <Button variant="raised" on:click={() => done('notes')}>
        <Label>Dalej</Label>
      </Button>
    </Content>
  </Panel>

  <Panel class="acc"  bind:open={panels.agreements.open} nonInteractive={!panels.agreements.active}>
    <Header>
      <strong>Formalności</strong>
      <div slot="icon">
        <Icon class="material-icons">{panels.agreements.value ? 'check' : ''}</Icon>
        <Icon class="material-icons">{panels.agreements.active && !panels.agreements.value ? 'edit' : ''}</Icon>
      </div>
    </Header>
    <Content>
        <div class="row row-1">
          <FormField>
            <Checkbox bind:checked={regulations}  />
            <span slot="label">Akceptuję <a href="/regulamin" target="_blank">regulamin</a> sklepu internetowego.</span>
          </FormField>
        </div>
        <div class="row row-1"></div>
        <div class="row row-1">
          <FormField>
            <Checkbox bind:checked={privacy_policy} />
            <span slot="label">Zapoznałem/am się z <a href="/polityka-prywatnosci" target="_blank">polityką prywatności</a> sklepu internetowego.</span>
          </FormField>
        </div>
    </Content>
  </Panel>
</Accordion>

<div class="actions">
  <button class="button" disabled={!regulations || !privacy_policy} on:click={submitForm}>Przejdź do podsumowania</button>
</div>
